import { useEffect } from "react";

/**
 * Reveals every element carrying a `data-reveal` attribute once it scrolls
 * into view (adds .is-revealed — see index.css). Pass the async data the
 * page renders from as deps so late-mounted elements get observed too.
 * Respects prefers-reduced-motion by revealing everything immediately.
 */
export default function useScrollReveal(deps = []) {
    useEffect(() => {
        const els = Array.from(document.querySelectorAll("[data-reveal]:not(.is-revealed)"));
        if (els.length === 0) return;

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
            els.forEach((el) => el.classList.add("is-revealed"));
            return;
        }

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-revealed");
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
